import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import PessoaForm from '../components/PessoaForm';
import { maskCPF, maskCNPJ } from '../utils/Masker';
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import CadastroRegistro from '../tutoriais/CadastroRegistro';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    tipoTela: this.props.tipoTela ? this.props.tipoTela : '',
    buscaOrdem: { campo: '', ordem: '' },
  };

  componentDidMount() {
    // console.log('componentDidMount', this.props.tipoTela)
    const usuario = getUsuario();
    this.setState({ usuario });
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina,
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { busca, pagina, limite, tipoTela, buscaOrdem } = this.state;
    axios
      .get('/pessoas', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          nome: busca,
          tipoTela,
          situacao: 'X'
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.pes_idf) { //editar      
      request = axios.put(`/pessoas/update/${registro.pes_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/pessoas/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Cliente gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/pessoas/show/${registro.pes_idf}`)
      .then(response => {
        const { data } = response;

        data.pes_municipio = {
          key: String(data.pes_municipio),
          label: data.cmun_descricao,
          cmun_uf: String(data.cmun_uf),
          cuf_sigla: data.cuf_sigla,
        }
        data.pes_grupo = {
          key: data.pes_grupo ? String(data.pes_grupo) : '0',
          label: data.grpes_descricao ? data.grpes_descricao : '',
        }

        data.pes_cpf_cnpj = data.pes_cpf_cnpj && data.pes_cpf_cnpj.length === 11 ? maskCPF(data.pes_cpf_cnpj) : data.pes_cpf_cnpj ? maskCNPJ(data.pes_cpf_cnpj) : '';
        data.pes_ind_ie = {
          key: data.pes_ind_ie ? String(data.pes_ind_ie) : '0',
          label: '',
        }

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            data,
            visualizar,
            tipoTela: this.state.tipoTela,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/pessoas/delete/${registro.pes_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.pes_idf === registro.pes_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto,
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        data: {
          pes_codigo: 0,
          pes_cliente: this.state.tipoTela === '' ? false : (this.state.tipoTela === 'C' ? true : false),
          pes_fornecedor: this.state.tipoTela === '' ? false : (this.state.tipoTela === 'F' ? true : false),
          pes_transportador: this.state.tipoTela === '' ? false : (this.state.tipoTela === 'T' ? true : false),
          pes_ind_ie: { key: '9', label: '0' },
          pes_municipio: {
            key: String(this.state.usuario.emp_municipio),
            label: this.state.usuario.cmun_descricao,
            cmun_uf: String(this.state.usuario.cmun_uf),
            cuf_sigla: this.state.usuario.cuf_sigla,
          },
          pes_grupo: { key: '0' },
        },
        tipoTela: this.state.tipoTela,
        visualizar: false,
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }





  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/pessoas/ativa/${registro.pes_idf}/1`)
    } else {
      request = axios.put(`/pessoas/ativa/${registro.pes_idf}/0`)
    }

    request.then(response => {
      registro.pes_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderAtiva = (pes_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={pes_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('PessoasPage', 'editar') ? false : true}
      />
    );
  };


  onBloqFinancChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/pessoas/bloqFinanc/${registro.pes_idf}/1`)
    } else {
      request = axios.put(`/pessoas/bloqFinanc/${registro.pes_idf}/0`)
    }

    request.then(response => {
      registro.pes_sit_fin = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderBloqFinanc = (pes_sit_fin, registro) => {
    return (
      <Switch
        checkedChildren="Bloqueado"
        unCheckedChildren="Liberado"
        checked={pes_sit_fin ? true : false}
        onChange={ativar => this.onBloqFinancChange(registro, ativar)}
        disabled={getTemPermissao('PessoasPage', 'editar') ? false : true}
      />
    );
  };




  // renderBloqFinanc = (pes_sit_fin, registro) => {
  //   return (
  //     <Switch
  //       checkedChildren="Bloqueado"
  //       unCheckedChildren="Liberado"
  //       checked={parseInt(pes_sit_fin) ? true : false}
  //       onChange={ativar => this.onBloqFinancChange(registro, ativar)}
  //       disabled={getTemPermissao('PessoasPage', 'editar') ? false : true}
  //     />
  //   );
  // };

  // onBloqFinancChange = (registro, ativar) => {
  //   this.setState({
  //     carregando: true
  //   })
  //   let request;

  //   console.log('onBloqFinancChange', ativar)
  //   if (ativar) {
  //     request = axios.put(`/pessoas/bloqFinanc/${registro.pes_idf}/1`)
  //   } else {
  //     request = axios.put(`/pessoas/bloqFinanc/${registro.pes_idf}/0`)
  //   }

  //   request.then(response => {
  //     registro.pes_sit_fin = ativar;
  //     this.setState({
  //       listaRegistros: this.state.listaRegistros.concat([]),
  //       carregando: false
  //     })
  //   }).catch(error => {
  //     console.error(error.response);
  //     this.setState({
  //       carregando: false
  //     })
  //   })
  // };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('PessoasPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('PessoasPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };


  renderPFJ = (pes_cpf_cnpj) => {
    if (pes_cpf_cnpj) {
      if ((String(pes_cpf_cnpj).length) === 11) {
        return (
          <span>
            {maskCPF(pes_cpf_cnpj)}
          </span>
        );
      } else {
        return (
          <span>
            {maskCNPJ(pes_cpf_cnpj)}
          </span>
        );
      }
    }
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite, tipoTela } = this.state;

    // console.log('PessoasPage.this.state', this.state);

    return (
      <div className="contentRoutesContainer">

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">{tipoTela === 'C' ? 'Cadastro de Clientes' : tipoTela === 'F' ? 'Cadastro de Fornecedores' : tipoTela === 'T' ? 'Cadastro de Transportadoras' : 'Cadastro de Clientes/Fornecedores'}</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              className="botao-ajuda"
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page1" />

        <div className="pageFiltro">
          {getTemPermissao('PessoasPage', 'novo') ? (
            <Button
              type="primary"
              onClick={this.onAdicionarClick}
              className="botao-primary"
            >
              Adicionar
            </Button>
          ) : null}

          <Search
            placeholder="Pesquisar..."
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <PessoaForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <CadastroRegistro
            isOpen={this.state.modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          rowKey={(registro => registro.pes_idf)}
        >
          <Column
            key="pes_codigo"
            dataIndex="pes_codigo"
            title={this.renderTitulo("Código")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={50}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pes_nome"
            dataIndex="pes_nome"
            title={this.renderTitulo("Nome")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={150}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pes_razao_social"
            dataIndex="pes_razao_social"
            title={this.renderTitulo("Razão Social")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={150}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pes_cpf_cnpj"
            dataIndex="pes_cpf_cnpj"
            title={this.renderTitulo("CPF/CNPJ")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderPFJ}
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cmun_descricao"
            dataIndex="cmun_descricao"
            title={this.renderTitulo("Município")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cuf_sigla"
            dataIndex="cuf_sigla"
            title={this.renderTitulo("UF")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={30}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="grpes_descricao"
            dataIndex="grpes_descricao"
            title={this.renderTitulo("Grupo")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={50}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pes_sit_fin"
            dataIndex="pes_sit_fin"
            title={this.renderTitulo("Sit Financ")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderBloqFinanc}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="pes_situacao"
            dataIndex="pes_situacao"
            title={this.renderTitulo("Situação")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderAtiva}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
            render={this.renderAcoes}
            width={70}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PessoasPage.js